type ApiAction = import('types/api').ApiPayloadAction
type ApiRequestConfig = import('types/api').ApiRequestConfig

export const getNeighborhood = (action: ApiAction): ApiRequestConfig => {
  const { focus, ids, depth } = action.payload
  return {
    url: '/graph/neighborhood',
    params: { focus, ids, depth }
  }
}
